// tslint:disable:max-line-length

import React from 'react';

export const ChartLine = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect y="15" width="16" height="1" />
      <polygon points="5.31 12.75 0 12.75 0 11.25 4.69 11.25 8 7.94 10.56 10.49 15.03 6.92 15.97 8.09 10.44 12.51 8 10.06 5.31 12.75" />
      <polygon points="4.37 9.25 0 9.25 0 7.75 3.63 7.75 7.23 3.12 10.27 4.13 13.94 0 15.06 1 10.73 5.87 7.77 4.88 4.37 9.25" />
    </svg>
  );
};
